<template lang="pug">
  .cross-sell-products(v-if="products && products.length")
    slot(:products="products")

</template>

<script>
  import vueXsellSvc from '@services/vueXsellSvc';

  export default {
    name: "CrossSellProducts",

    data() {
      return {
        products: null
      };
    },

    props: {
      productCode: {
        type: String
      }
    },

    created() {
      vueXsellSvc.getXsellItemsForProduct({ productCode: this.productCode}).then(res => {
        this.products = res.data;
      });
    }
  };
</script>

<style scoped lang="stylus">
</style>
